import './ViewAreaSidebar.scss';

import { Layout } from 'antd';

import React, { useEffect, useState } from 'react';
import { SonarMenu, SonarMenuItem } from '@ui/menu';
import { useLocation, useNavigate } from 'react-router-dom';

const { Sider } = Layout;

export interface ViewAreaSidebarProps {
	id?: string;
	items: Array<SonarMenuItem>;
}

export const ViewAreaSidebar: React.FC<ViewAreaSidebarProps> = ({ id, items }) => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const [ selected, setSelected ] = useState([ pathname ]);

	useEffect(() => {
		setSelected([ pathname ]);
	}, [ pathname ]);

	return (
		<div className='sidebar-container'>
			<Sider
				className='view-area-sidebar'
				id={ id }
				theme='light'>
				<SonarMenu
					items={ items }
					onClick={ (info) => navigate(info.key) }
					selectedKeys={ selected } />
			</Sider>
		</div>
	);
};
